// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== POST CONTAINER ==================== */

.uacp-post-container {
  position: relative;
  width: 100%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1.5rem;
  border-radius: 10px;
  /* background: rgb(34, 31, 31); */
  margin-bottom: 3rem; /* ✅ Space for footer */
  overflow: visible;
  background: rgba(36,36,45,0.2);
  border: 1px solid var(--border-color, rgb(52, 51, 51));
}

/* ==================== USER FEED ==================== */

.uacp-user-feed {
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 10px;
}

/* ==================== POST CARD ==================== */

.uacp-post-card {
  height: auto;
  width: 100%;
  border-radius: 10px;
  background: none;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
}

/* ==================== USER CONTAINER ==================== */

.uacp-user-container {
  width: 100%;
  background: none;
  height: auto;
  min-height: 60px;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.uacp-user-info-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  position: relative;
}

.uacp-user-avatar-wrapper {
  width: 40px;
  height: 40px;
  margin-left: 0.5rem;
  flex-shrink: 0;
}

.uacp-user-name-wrapper {
  margin-left: 0.75rem;
  flex-shrink: 0;
}

.uacp-user-link {
  text-decoration: none;
  color: inherit;
}

/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */

.uacp-profile-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.2), rgba(255, 165, 0, 0.2));
  border: 1px solid rgba(255, 215, 0, 0.4);
  border-radius: 20px;
  padding: 0.4rem 1rem;
  margin-left: 1rem;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.15);
  transition: all 0.3s ease;
}

.uacp-profile-badge:hover {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.3), rgba(255, 165, 0, 0.3));
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.25);
}

.uacp-profile-link {
  text-decoration: none;
  color: #ffd700;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.uacp-profile-name {
  font-weight: 700;
  color: #ffed4e;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.uacp-profile-disabled {
  color: #888;
  font-size: 0.9rem;
  cursor: not-allowed;
  opacity: 0.6;
}

/* ==================== LOCATION & TIME ==================== */

.uacp-location-time-wrapper {
  display: flex;
  flex-direction: row;
  height: auto;
  min-height: 30px;
  margin-bottom: 0.5rem;
}

.uacp-feed-header {
  min-height: 10px;
  height: auto;
  width: 100%;
  font-size: 1rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  background: none;
  margin-left: 0.5rem;
}

.uacp-location-link {
  color: white;
  text-decoration: none;
}

/* ==================== FEED MEDIA ==================== */

.uacp-feed-media {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 1rem;
  width: 100%;
  height: auto;
  margin: 0.75rem 0;
  text-align: left;
  background: none;
  box-sizing: border-box;
}

.uacp-post-description {
  margin-left: 0.5rem;
  margin-bottom: 1rem;
}

.uacp-feed-media-container {
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-top: 1rem;
  overflow: hidden;
}

/* ==================== POST STATS ==================== */

.uacp-post-stats-wrapper {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
}

.uacp-post-stats-left {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  height: auto;
  min-height: 30px;
  overflow: hidden;
  align-items: center;
  padding: 5px;
}

.uacp-post-stats-right {
  width: 100%;
  height: auto;
  min-height: 30px;
  overflow: hidden;
  text-align: left;
}

.uacp-impressions-text {
  font-size: 1rem;
  color: white;
  font-weight: normal;
}

/* ==================== COMMENTS SECTION ==================== */

.uacp-comments-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  padding-bottom: 1rem;
}

.uacp-feed-comments {
  width: 100%;
  margin-bottom: 1rem;
}

.uacp-comments-title {
  font-weight: bold;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
}

.uacp-comments-container {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 0.5rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.uacp-comments-container::-webkit-scrollbar {
  display: none;
}

.uacp-comment-item {
  margin-bottom: 0.5rem;
  height: auto;
  min-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.5rem;
}

.uacp-comment-link {
  text-decoration: none;
  color: inherit;
}

.uacp-no-comments {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
  margin-left: 0.5rem;
}

/* ==================== LOADING STATE ==================== */

.uacp-loading {
  text-align: center;
  padding: 2rem;
  color: rgba(255, 255, 255, 0.6);
}

/* ==================== RESPONSIVE ==================== */

@media (max-width: 768px) {
  .uacp-post-container {
    padding: 0.75rem;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .uacp-post-card {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }

  .uacp-profile-badge {
    margin-left: 0;
    margin-top: 0.5rem;
    width: 100%;
    justify-content: center;
  }

  .uacp-feed-header {
    font-size: 0.9rem;
  }

  .uacp-post-stats-left {
    gap: 1rem;
  }

  .uacp-impressions-text {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .uacp-post-container {
    padding: 0.5rem;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .uacp-post-card {
    padding: 0.5rem;
  }

  .uacp-user-avatar-wrapper {
    width: 32px;
    height: 32px;
  }

  .uacp-post-stats-left {
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .uacp-profile-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UAPostContent.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB,EAAE,uBAAuB;EAC5C,iBAAiB;EACjB,8BAA8B;EAC9B,sDAAsD;AACxD;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wDAAwD;;AAExD;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,6DAA6D;;AAE7D;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0EAA0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mFAAmF;EACnF,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,mFAAmF;EACnF,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf;wEACsE;EACtE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yDAAyD;;AAEzD;EACE;wEACsE;EACtE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4DAA4D;;AAE5D;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA,yDAAyD;;AAEzD;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF","sourcesContent":["/* ==================== POST CONTAINER ==================== */\n\n.uacp-post-container {\n  position: relative;\n  width: 100%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1.5rem;\n  border-radius: 10px;\n  /* background: rgb(34, 31, 31); */\n  margin-bottom: 3rem; /* ✅ Space for footer */\n  overflow: visible;\n  background: rgba(36,36,45,0.2);\n  border: 1px solid var(--border-color, rgb(52, 51, 51));\n}\n\n/* ==================== USER FEED ==================== */\n\n.uacp-user-feed {\n  position: relative;\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n  background: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  border-radius: 10px;\n}\n\n/* ==================== POST CARD ==================== */\n\n.uacp-post-card {\n  height: auto;\n  width: 100%;\n  border-radius: 10px;\n  background: none;\n  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n}\n\n/* ==================== USER CONTAINER ==================== */\n\n.uacp-user-container {\n  width: 100%;\n  background: none;\n  height: auto;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.uacp-user-info-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  position: relative;\n}\n\n.uacp-user-avatar-wrapper {\n  width: 40px;\n  height: 40px;\n  margin-left: 0.5rem;\n  flex-shrink: 0;\n}\n\n.uacp-user-name-wrapper {\n  margin-left: 0.75rem;\n  flex-shrink: 0;\n}\n\n.uacp-user-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */\n\n.uacp-profile-badge {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.2), rgba(255, 165, 0, 0.2));\n  border: 1px solid rgba(255, 215, 0, 0.4);\n  border-radius: 20px;\n  padding: 0.4rem 1rem;\n  margin-left: 1rem;\n  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.15);\n  transition: all 0.3s ease;\n}\n\n.uacp-profile-badge:hover {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.3), rgba(255, 165, 0, 0.3));\n  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.25);\n}\n\n.uacp-profile-link {\n  text-decoration: none;\n  color: #ffd700;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.uacp-profile-name {\n  font-weight: 700;\n  color: #ffed4e;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.uacp-profile-disabled {\n  color: #888;\n  font-size: 0.9rem;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ==================== LOCATION & TIME ==================== */\n\n.uacp-location-time-wrapper {\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  min-height: 30px;\n  margin-bottom: 0.5rem;\n}\n\n.uacp-feed-header {\n  min-height: 10px;\n  height: auto;\n  width: 100%;\n  font-size: 1rem;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  background: none;\n  margin-left: 0.5rem;\n}\n\n.uacp-location-link {\n  color: white;\n  text-decoration: none;\n}\n\n/* ==================== FEED MEDIA ==================== */\n\n.uacp-feed-media {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 1rem;\n  width: 100%;\n  height: auto;\n  margin: 0.75rem 0;\n  text-align: left;\n  background: none;\n  box-sizing: border-box;\n}\n\n.uacp-post-description {\n  margin-left: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.uacp-feed-media-container {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  margin-top: 1rem;\n  overflow: hidden;\n}\n\n/* ==================== POST STATS ==================== */\n\n.uacp-post-stats-wrapper {\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.uacp-post-stats-left {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  width: 100%;\n  height: auto;\n  min-height: 30px;\n  overflow: hidden;\n  align-items: center;\n  padding: 5px;\n}\n\n.uacp-post-stats-right {\n  width: 100%;\n  height: auto;\n  min-height: 30px;\n  overflow: hidden;\n  text-align: left;\n}\n\n.uacp-impressions-text {\n  font-size: 1rem;\n  color: white;\n  font-weight: normal;\n}\n\n/* ==================== COMMENTS SECTION ==================== */\n\n.uacp-comments-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.uacp-feed-comments {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.uacp-comments-title {\n  font-weight: bold;\n  margin-left: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.uacp-comments-container {\n  width: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.uacp-comments-container::-webkit-scrollbar {\n  display: none;\n}\n\n.uacp-comment-item {\n  margin-bottom: 0.5rem;\n  height: auto;\n  min-height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 0.5rem;\n}\n\n.uacp-comment-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.uacp-no-comments {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n  margin-left: 0.5rem;\n}\n\n/* ==================== LOADING STATE ==================== */\n\n.uacp-loading {\n  text-align: center;\n  padding: 2rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ==================== RESPONSIVE ==================== */\n\n@media (max-width: 768px) {\n  .uacp-post-container {\n    padding: 0.75rem;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .uacp-post-card {\n    padding: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .uacp-profile-badge {\n    margin-left: 0;\n    margin-top: 0.5rem;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .uacp-feed-header {\n    font-size: 0.9rem;\n  }\n\n  .uacp-post-stats-left {\n    gap: 1rem;\n  }\n\n  .uacp-impressions-text {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .uacp-post-container {\n    padding: 0.5rem;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .uacp-post-card {\n    padding: 0.5rem;\n  }\n\n  .uacp-user-avatar-wrapper {\n    width: 32px;\n    height: 32px;\n  }\n\n  .uacp-post-stats-left {\n    gap: 0.75rem;\n    flex-wrap: wrap;\n  }\n\n  .uacp-profile-badge {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
